import axios from "axios";
import config from "../config";
import { FormResponse } from "./ResponseModels/FormResponse";

export async function PostFormModel(
  created_on: Date,
  title: string,
  channel: string,
  content_type: string,
  season_number: number,
  episode_number: number,
  tx_date: Date,
  need_by_date: Date,
  notes: string
) {
  let response = null;
  response = axios
    .post<FormResponse>(config.getFormEndpoint, {
      created_on: created_on,
      title: title,
      channel: channel,
      content_type: content_type,
      season_number: season_number,
      episode_number: episode_number,
      tx_date: tx_date,
      need_by_date: need_by_date,
      notes: notes,
    })
    .catch((e) => {
      // TODO manage
      console.error("There was an error!", e);
    });

  return response;
}
